// import path from "path";
import React from "react";

const MainLayout = React.lazy(
  () => import("../../components/Layout/MainLayout")
);
const AuthLayout = React.lazy(
  () => import("../../components/Layout/AuthLayout")
);
const DrivePage = React.lazy(
  () => import("@/features/drive/pages/DrivePage/DrivePage")
);
const LoginPage = React.lazy(() => import("@/features/auth/pages/LoginPage"));
const NotFoundPage = React.lazy(() => import("../NotFoundPage/NotFoundPage"));
// const TestRabbitMq = React.lazy(()=> import("@/pages/Test/TestRabbitMq"))
const TestWorkflow = React.lazy(()=> import("@/pages/Test/TestWorkflow"))
const SheetViewer = React.lazy(()=> import("@/features/sheet-viewer/pages/SheetViewer"))
const TrashPage = React.lazy(() => import("@/features/trash/pages/TrashPage"))
const EmptyOrganizationsPage = React.lazy(() => import("@/features/projects/pages/EmptyOrganizationsPage/EmptyOrganizationsPageWrapper"))
const SettingPage = React.lazy(() => import("@/features/settings/pages/SettingPage"))
const GroupUserTab = React.lazy(() => import("@/features/settings/components/group/GroupUserTab"))
const SystemSettingTab = React.lazy(() => import("@/features/settings/components/group/SystemSettingTab"))
const GroupDetailPage = React.lazy(() => import("@/features/settings/components/group/GroupDetailPage"))
const StorageManagement = React.lazy(() => import("@/features/settings/components/StorageManagement/StorageManagement"))

const RouterArr = [
  {
    path: "/page",
    component: MainLayout,
    exact: true,
    isNotPrivate: true,
    children: [
      {
        index: true,
        component: DrivePage,
        isNotPrivate: true,
      },
      {
        // Unified drive route - workspace determined by Redux state
        path: "drive",
        component: DrivePage,
        isNotPrivate: true,
      },

      // {
      //   path: "trash",
      //   component: TrashPage,
      //   isNotPrivate: true,
      // },

      {
        path: "empty-organizations",
        component: EmptyOrganizationsPage,
        isNotPrivate: true,
      },

      {
        path: "settings",
        component: SettingPage,
        isNotPrivate: true,
        requireAdmin: true,
        children: [
          {
            path: "groups",
            component: GroupUserTab,
          },
          {
            path: "system",
            component: SystemSettingTab,
          },
          {
            path: "storage",
            component: StorageManagement,
          },
        ],
      },

      {
        path: "settings/groups/:groupId",
        component: GroupDetailPage,
        isNotPrivate: true,
        requireAdmin: true,
      },

    ],
  },
  // {
  //   path: "projects",
  //   component: AccountPage,
  //   exact: true,
  //   isNotPrivate: true,
  // },
  // {
  //   path: "/test",
  //   component: TestRabbitMq,
  //   exact: true,
  //   isNotPrivate: true,
  // },

  {
    path: "/test2",
    component: TestWorkflow,
    exact: true,
    isNotPrivate: true,
  },

  {
    path: "/sheet",
    component: SheetViewer,
    exact: true,
    isNotPrivate: true,
  },
  {
    path: "/auth",
    component: AuthLayout,
    exact: true,
    isNotPrivate: true,
    children: [
      {
        path: "login",
        component: LoginPage,
        isNotPrivate: true,
      },
    ],
  },
  {
    path: "*",
    component: NotFoundPage,
    isNotPrivate: true,
  },
];

export default RouterArr;
